import Login from './views/cdwgkj/Login.vue'
import NotFound from './views/404.vue'
import CardLogin from './views/cdwgkj/CardLogin.vue'
import CardProduct from './views/cdwgkj/CardProduct.vue'
import ReservationOrder from './views/cdwgkj/ReservationOrder.vue'
import UserReservationOrder from './views/cdwgkj/UserReservationOrder.vue'
import UserCardReservationOrder from './views/cdwgkj/userCardReservationOrder.vue'
import ServiceReservationOrder from './views/cdwgkj/ServiceReservationOrder.vue'
import DeliverReservationOrder from './views/cdwgkj/DeliverReservationOrder.vue'
import ServiceProductOrder from './views/cdwgkj/ServiceProductOrder.vue'
import ServiceProduct from './views/cdwgkj/ServiceProduct.vue'
import Main from './views/Main.vue'
let routes = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        hidden: true
    },
    {
        path: '/cardLogin',
        component: CardLogin,
        name: '',
        hidden: true
    },
    {
        path: '/cardProduct',
        props: true,
        component: CardProduct,
        name: '',
        hidden: true
    },
    {
        path: '/reservationOrder',
        props: true,
        component: ReservationOrder,
        name: '',
        hidden: true
    },
    {
        path: '/userReservationOrder',
        props: true,
        component: UserReservationOrder,
        name: '',
        hidden: true
    },
    {
        path: '/userCardReservationOrder',
        props: true,
        component: UserCardReservationOrder,
        name: '',
        hidden: true
    },
    {
        path: '/serviceReservationOrder',
        props: true,
        component: ServiceReservationOrder,
        name: '',
        hidden: true
    },
    {
        path: '/deliverReservationOrder',
        props: true,
        component: DeliverReservationOrder,
        name: '',
        hidden: true
    },
    {
        path: '/serviceProductOrder',
        props: true,
        component: ServiceProductOrder,
        name: '',
        hidden: true
    },
    {
        path: '/serviceProduct',
        props: true,
        component: ServiceProduct,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Login,
        name: 'login',
        hidden: true
    },
    /*{
        path: '/pick',
        component: Login,
    },*/
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
    //{ path: '/main', component: Main },
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js